import { Chip, Fade } from '@mui/material';
import { useAtomValue } from 'jotai';
import { fundFilterStateAtom } from '../../../../../components/Layout/Navbar/Navigation/PortfolioReporting/FundNavigation/FundFilterSingleSelect';
import { ViewTypeByData } from '../../../../../data-models/view-config.data-model';
import { ViewModel } from '../../../../../models/view.model';
import { fundsByIdMapAtom } from '../../../../../services/state/AppConfigStateJ';
import { colors } from '../../../../../theme/colors';
import { pluralizeWord } from '../../../../../util/stringUtils';
import { usePfFilterState } from '../PfState';

export function AppliedFiltersIndicator({ view }: { view: ViewModel }) {
  if (view.viewType === ViewTypeByData.multiperiod) {
    return <MprFilterIndicator />;
  }
  return <AppliedFiltersIndicatorOverview view={view} />;
}

export function AppliedFiltersIndicatorOverview({ view }: { view: ViewModel }) {
  const appliedFilters = usePfFilterState(view);

  if (!appliedFilters.length) {
    return null;
  }

  return (
    <Fade in={true} exit={true} timeout={1000}>
      <Chip
        title={appliedFilters.join(', ')}
        label={`${appliedFilters.length} ${pluralizeWord('filter', appliedFilters.length)} applied`}
        sx={{ '&:hover': { background: `${colors.neutral[20]}99` } }}
      />
    </Fade>
  );
}

export function MprFilterIndicator() {
  const fundId = useAtomValue(fundFilterStateAtom);
  const fundsById = useAtomValue(fundsByIdMapAtom);
  const fundName = fundsById.get(fundId || -1)?.name;
  if (!fundId || !fundName) {
    return null;
  }

  return (
    <Fade in={true} exit={true} timeout={1000}>
      <Chip title={fundName} label={fundName} sx={{ '&:hover': { background: `${colors.neutral[20]}99` } }} />
    </Fade>
  );
}
